import { WidgetProps } from '@rjsf/utils';
import { useMemo } from 'react';
import { MultiSelectDropdown } from '../../../../ui/components/pure/dropdown/multi-select-dropdown.component';

export function DynamicFormMultiselect(props: WidgetProps) {
  const menuItems = useMemo(() => {
    const items = (props.schema.items as any)?.anyOf || [];
    if (!Array.isArray(items)) {
      return [];
    }
    return items
      .filter((item) => !!item)
      .map((option: any) => ({
        label: option.title,
        value: option.enum?.[0]
      }));
  }, [props.schema.items]);

  // When no value is selected, the WidgetProps value can be an list of [undefined]
  const sanitizedValue = useMemo(() => {
    const sanitized = Array.isArray(props.value) ? props.value.filter((v) => v !== undefined) : [];
    if (sanitized.length === 0) {
      return undefined;
    }
    return sanitized;
  }, [props.value]);

  return (
    <MultiSelectDropdown
      key={sanitizedValue ? sanitizedValue.join(',') : 'none'} // Force re-mount when value changes
      multiple
      fullWidth
      textFieldDesktopWidth="100%"
      menuItems={menuItems}
      onChange={props.onChange}
      label={props.label}
      placeholder={props.label}
      dropdownVariant="floating"
      value={sanitizedValue}
      disabled={props.disabled || props.readonly}
    />
  );
}
